/* unika özel düzeltmeler (toserof) — 2026-07-17
   Beden seçeneklerini büyüklük sırasına dizer (ürün verisinde karışık girilmiş olsa bile).
   Sıra: harf bedenler (XXS→6XL) önce, sonra numerik bedenler (36→38→40...), bilinmeyenler en sonda.
   PDP + hızlı görünüm/quick-add içindeki buton ve dropdown seçicilerde çalışır. */
(function () {
  var LETTERS = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', 'XXXL', '3XL', '4XL', '5XL', '6XL'];

  function rank(value) {
    var t = String(value).trim().toLocaleUpperCase('tr').replace(/İ/g, 'I');
    var i = LETTERS.indexOf(t);
    if (i > -1) return [0, i];
    if (/^[0-9]+([.,][0-9]+)?$/.test(t)) return [1, parseFloat(t.replace(',', '.'))];
    return [2, 0];
  }

  function isSizeName(s) {
    s = String(s || '').replace(':', '').trim().toLocaleLowerCase('tr');
    return s === 'beden' || s === 'size' || s === 'numara' || s.indexOf('beden') === 0;
  }

  function sortChildren(container, items, getValue) {
    var arr = Array.prototype.slice.call(items);
    if (arr.length < 2) return;
    var orig = arr.map(function (el, i) { return { el: el, r: rank(getValue(el)), i: i }; });
    var sorted = orig.slice().sort(function (a, b) {
      return a.r[0] - b.r[0] || a.r[1] - b.r[1] || a.i - b.i;
    });
    var changed = sorted.some(function (o, idx) { return o.el !== orig[idx].el; });
    if (!changed) return; /* zaten sıralı: tekrar dokunma (observer döngüsünü de kırar) */
    sorted.forEach(function (o) { container.appendChild(o.el); });
  }

  function run() {
    /* buton / swatch stili seçiciler */
    document.querySelectorAll('.variant-option--buttons').forEach(function (group) {
      var labelEl = group.querySelector('.variant-option__label-text');
      if (!labelEl || !isSizeName(labelEl.textContent)) return;
      sortChildren(group, group.querySelectorAll(':scope > label'), function (el) {
        var inp = el.querySelector('input');
        return inp ? inp.value : el.textContent;
      });
    });
    /* dropdown stili seçiciler */
    document.querySelectorAll('.variant-option--dropdowns').forEach(function (group) {
      var labelEl = group.querySelector('.variant-option__label-text');
      var sel = group.querySelector('select');
      if (!sel || !labelEl || !isSizeName(labelEl.textContent)) return;
      sortChildren(sel, sel.querySelectorAll('option'), function (el) { return el.value; });
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; run(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  /* quick-view modalı ve varyant değişiminde yeniden basılan seçiciler için */
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });

  /* Carousel resize sigortası: pencere boyutu/yön değişince tüm carousel'leri
     zorla güncelle — resize sırasında yarım kalan slide yerleşimlerini toparlar
     (ör. KATEGORİLERİMİZ bölümünde kartlar arasında boşluk kalması). */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('carousel-slider').forEach(function (c) {
        var s = c.swiperInstance;
        if (s && !s.destroyed) { try { s.update(); } catch (e) { /* sessiz */ } }
      });
    }, 250);
  });
})();


/* ===== Favoriler (EDME audit #36) — 2026-10-08 =====
   Üyelik gerektirmez; favoriler tarayıcıda (localStorage) saklanır.
   - Ürün kartlarına ve ürün sayfasına kalp butonu ekler
   - Header'a favori ikonu + sayaç ekler (/pages/favorilerim)
   - /pages/favorilerim sayfasında #unika-wishlist alanına listeyi basar */
(function () {
  var KEY = 'unika_wishlist_v1';
  var PAGE = '/pages/favorilerim';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.6-9.1C1 8.3 2.8 4.5 6.5 4.5c2.2 0 3.6 1.3 4.5 2.7.9-1.4 2.3-2.7 4.5-2.7 3.7 0 5.5 3.8 4.1 6.9-2.1 4.5-9.6 9.1-9.6 9.1z"/></svg>';

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* gizli mod vb. */ }
    document.dispatchEvent(new CustomEvent('unika:wishlist'));
  }
  function has(h) { return read().indexOf(h) > -1; }
  function toggle(h) {
    var list = read();
    var i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.unshift(h);
    write(list.slice(0, 100));
  }
  function handleFromHref(href) {
    var m = String(href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function label(active) { return active ? 'Favorilerden çıkar' : 'Favorilere ekle'; }

  function makeBtn(h, cls) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls;
    b.setAttribute('data-wish', h);
    b.innerHTML = HEART + (cls === 'unika-wish-pdp' ? '<span>Favorilere ekle</span>' : '');
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggle(h);
    });
    return b;
  }

  function decorateCards() {
    document.querySelectorAll('product-card .product-card__media, .cshowcase-card__media').forEach(function (media) {
      if (media.querySelector(':scope > .unika-wish-btn')) return;
      var card = media.closest('product-card, .cshowcase-card');
      if (!card) return;
      var a = card.querySelector('a[href*="/products/"]');
      var h = a && handleFromHref(a.getAttribute('href'));
      if (!h) return;
      media.appendChild(makeBtn(h, 'unika-wish-btn'));
    });
  }

  function decoratePdp() {
    var h = handleFromHref(location.pathname);
    if (!h || document.querySelector('.unika-wish-pdp')) return;
    var title = document.querySelector('[class*="__product_title_"]') || document.querySelector('main h1');
    if (!title || title.closest('product-card, dialog')) return;
    title.insertAdjacentElement('afterend', makeBtn(h, 'unika-wish-pdp'));
  }

  function decorateHeader() {
    if (document.querySelector('.unika-wish-header')) return;
    var cart = document.querySelector('.header__buttons a[href$="/cart"], a.cart-drawer-button');
    if (!cart || !cart.parentElement) return;
    var a = document.createElement('a');
    a.href = PAGE;
    a.className = 'unika-wish-header';
    a.setAttribute('aria-label', 'Favorilerim');
    a.innerHTML = HEART + '<span class="unika-wish-header__count" hidden></span>';
    cart.parentElement.insertBefore(a, cart);
  }

  function sync() {
    var list = read();
    document.querySelectorAll('[data-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-wish')) > -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', label(on));
      b.title = label(on);
      var t = b.querySelector('span');
      var txt = on ? 'Favorilerde' : 'Favorilere ekle';
      if (t && b.classList.contains('unika-wish-pdp') && t.textContent !== txt) t.textContent = txt;
    });
    document.querySelectorAll('.unika-wish-header__count').forEach(function (c) {
      if (c.textContent !== String(list.length)) c.textContent = list.length;
      c.hidden = list.length === 0;
    });
  }

  function money(cents) {
    return (Number(cents) / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function renderPage() {
    var root = document.getElementById('unika-wishlist');
    if (!root) return;
    var list = read();
    if (!list.length) {
      root.innerHTML = '<div class="unika-wishlist"><p class="unika-wishlist__empty">Henüz favori ürününüz yok. Beğendiğiniz ürünlerdeki kalp ikonuna dokunarak buraya ekleyebilirsiniz.</p></div>';
      return;
    }
    root.innerHTML = '<div class="unika-wishlist"><p class="unika-wishlist__empty">Yükleniyor…</p></div>';
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      var alive = items.filter(Boolean);
      if (alive.length !== list.length) write(alive.map(function (p) { return p.handle; }));
      if (!alive.length) { renderPage(); return; }
      var html = alive.map(function (p) {
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
        var cmp = p.compare_at_price && p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '';
        return '<div class="unika-wishlist__item">' +
          '<a class="unika-wishlist__img" href="/products/' + p.handle + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<button type="button" class="unika-wish-btn" data-wish="' + esc(p.handle) + '">' + HEART + '</button>' +
          '<a class="unika-wishlist__title" href="/products/' + p.handle + '">' + esc(p.title) + '</a>' +
          '<div class="unika-wishlist__price">' + money(p.price) + cmp + '</div>' +
          (p.available ? '' : '<div class="unika-wishlist__soldout">Tükendi</div>') +
          '</div>';
      }).join('');
      root.innerHTML = '<div class="unika-wishlist"><div class="unika-wishlist__grid">' + html + '</div></div>';
      root.querySelectorAll('.unika-wish-btn').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); toggle(b.getAttribute('data-wish')); renderPage(); });
      });
      sync();
    });
  }

  function run() { decorateHeader(); decorateCards(); decoratePdp(); sync(); }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(run, 150); }
  document.addEventListener('unika:wishlist', sync);
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); renderPage(); });
  } else { run(); renderPage(); }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ===== Beden ölçü tablosu (audit #35) — native <dialog>: Esc ile kapanır, odak dialog içinde kalır ===== */
(function () {
  var lastOpener = null;
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-unika-sc-open]');
    if (open) {
      var d = document.getElementById(open.getAttribute('data-unika-sc-open'));
      if (d && typeof d.showModal === 'function') { lastOpener = open; d.showModal(); open.setAttribute('aria-expanded', 'true'); d.querySelector('[data-unika-sc-close]') && d.querySelector('[data-unika-sc-close]').focus(); }
      return;
    }
    var close = e.target.closest('[data-unika-sc-close]');
    if (close) { var dlg = close.closest('dialog'); if (dlg) dlg.close(); return; }
    if (e.target.classList && e.target.classList.contains('unika-sc__dialog')) { e.target.close(); }
  });
  document.addEventListener('close', function (e) {
    if (e.target.classList && e.target.classList.contains('unika-sc__dialog') && lastOpener) { lastOpener.setAttribute('aria-expanded', 'false'); lastOpener.focus(); lastOpener = null; }
  }, true);
})();
